import { reactive } from 'vue'

import logger from '@/services/logger'

/**
 * Estado singleton compartilhado com ImoModalManager.vue
 * Não exportar diretamente para o restante da aplicação —
 * apenas ImoModalManager.vue deve importar modalState.
 */
export const modalState = reactive({
  show: false,
  type: null,
  options: {},
  resolve: null,
  mounted: false, // true quando ImoModalManager está montado no App.vue
})

/**
 * Exibe um modal programático e retorna Promise com a ação escolhida.
 *
 * @param {string} type - Tipo do modal ('pending-issues', 'error', 'success', etc)
 * @param {object} options - Opções específicas para cada tipo de modal
 * @returns {Promise<string|null>} - Ação escolhida pelo usuário ou null se cancelado
 *
 * @example
 * // Modal de erro genérico
 * await showModal('error', {
 *   title: 'Falha na operação',
 *   message: 'Não foi possível processar sua solicitação.'
 * })
 */
export function showModal(type, options = {}) {
  // Fallback se ImoModalManager não estiver montado
  if (!modalState.mounted) {
    logger.warn('[ImoModalManager] Not mounted. Modal request ignored:', type)
    return Promise.resolve(null)
  }

  // Se o mesmo tipo de modal já estiver aberto, não reabrir.
  // Útil para modais com dados reativos (ex: pdf-generation-success com fila de relatórios).
  if (modalState.show && modalState.type === type) {
    return Promise.resolve(null)
  }

  return new Promise(resolve => {
    modalState.type = type
    modalState.options = options
    modalState.show = true
    modalState.resolve = resolve
  })
}

/**
 * Fecha o modal programaticamente
 */
export function closeModal() {
  if (modalState.resolve) {
    modalState.resolve(null)
    modalState.resolve = null
  }
  modalState.show = false
  modalState.type = null
  modalState.options = {}
}
